module.exports = __webpack_public_path__ + "static/media/kick.abbfd5a2.mp3";